<template>
  <div ref="cascader">
    <el-select :popper-append-to-body="false" v-model="value" @change="handleChange"   ref="multiSelect"  :placeholder="placeholder" @click="hooseCustom()">
      <!-- <el-option value="">{{ placeholder }}</el-option> -->
      <el-option v-for="option, index in options" :label="option.title" :value="option.value" :key="index"></el-option>
    </el-select>

    <MyCascader v-if="selectedOption && ('subs' in selectedOption)" :placeholders="placeholders"
      :options="selectedOption.subs" :value="childValue" @change="handleChildChange" ref="myCascader" />

  </div>
</template>
<style scoped>
.el-select {
  width: calc(100%);
  margin-bottom: 10px;
}
</style>

<script>

import FastClick from 'fastclick'
export default {

  name: 'MyCascader',
  props: {
    options: {
      type: Array,
      required: true,
    },
    placeholder: {
      type: String,
      default: '-请选择-',
    },
    placeholders: {
      type: String,
      default: '-请选择-',
    },
  },
  data() {
    return {
      value: undefined,
      selectedOption: null,
      childValue: [],
      subValue: '',
      placeholderList: '',

      isCascaderOpen: false, // 追踪下拉框是否展开的变量
    };
  },
  mounted() {
    // FastClick.attach(this.$refs.cascader);
    console.log(this.placeholder);
    const inputString = this.placeholders;
    this.placeholderList = this.parseStringToListItems(inputString);
    console.log(this.placeholderList);

  },
  methods: {

    hooseCustom() {
      //调用element-ui select组件blur方法
      //要包再timeout里面，直接调用不会关闭下拉框option
      setTimeout(() => {
        this.$refs.multiSelect.blur()
      }, 50)
    },


    closeOtherCascaders() {
      // 关闭其他下拉框的方法
      if (this.isCascaderOpen) {
        this.$refs.myCascader.close();
      }
    },

    handleTouchStart(event) {
      // 获取触摸事件的触发元素
      const target = event.target;

      // 判断触摸事件的触发元素是否在下拉框内部
      const dropdown = this.$el.querySelector('.el-select-dropdown');
      if (!dropdown || dropdown.contains(target)) {
        // 触摸在下拉框内部，不处理
        return;
      }

      // 触摸在下拉框外部，关闭下拉框
      this.$refs.select.close();
    },

    handleClickOutside() {
      if (this.$refs.myCascader) {
        this.$refs.myCascader.value = []; // 清空子级选择器的选中值
        console.log('12333');
      }
    },
    parseStringToListItems(inputString) {
      const regex = /(\d+\.\s+)(.*?)(?=\d+\.\s+|\n|$)/g;
      const items = inputString.match(regex);

      if (!items) return [];

      return items.map((item) => {
        const [_, index, content] = item.match(/(\d+\.\s+)(.*)/);
        return {
          index: parseInt(index, 10),
          content: content.trim(),
        };
      });
    },
    handleChange() {
      console.log(this.childValue);
      this.subValue++
      if (!this.childValue.length) {
        this.childValue = []; // 清空子级选项数组
      }
      // 使用 $nextTick 确保 DOM 更新完成
      this.$nextTick(() => {
        if (this.$refs.myCascader) {
          this.$refs.myCascader.value = []; // 清空子级选择器的选中值
          this.$refs.myCascader.placeholder = this.placeholderList[1].content
        }
      });
      this.selectedOption = this.options.find(option => option.value === this.value);

      this.$emit('change', [this.value]);
      console.log(this.selectedOption);
    },
    handleChildChange(value) {
      this.childValue = value;
      this.$emit('change', [this.value, ...value]);
    },
  },
};
</script>
